import {getQueryStringObject} from '@vio/core/src/_web/utils/url'

const AUTO_REFRESH_INTERVAL_MS = 25 * 60 * 1000 // 25 minutes
const AUTO_REFRESH_MIN_INTERVAL_MS = 10 * 1000 // 10 seconds (minimum to prevent API abuse if user manually pass the refresh timeout)

/**
 * Returns the auto-refresh interval for offers or rooms based on URL query parameters.
 * Reads `auto_refresh_timeout` from the current URL.
 * Allows overriding the default interval via `auto_refresh_timeout` query param,
 * with a minimum threshold to prevent API abuse.
 * @returns The auto-refresh interval in milliseconds
 */
export const getAutoRefreshInterval = (): number => {
  if (typeof window === 'undefined') {
    return AUTO_REFRESH_INTERVAL_MS
  }
  const params = getQueryStringObject()
  const parsed = Number(params?.auto_refresh_timeout)
  if (!Number.isNaN(parsed) && parsed > 0) {
    return Math.max(AUTO_REFRESH_MIN_INTERVAL_MS, parsed)
  }
  return AUTO_REFRESH_INTERVAL_MS
}
